<div 
  *ngIf="isOpen"
  class="modal-overlay"
  (click)="handleOverlayClick($event)"
  tabindex="-1"
  role="dialog"
  [attr.aria-label]="ariaLabel"
  [attr.aria-modal]="true"
  [attr.aria-hidden]="!isOpen"
>
  <div 
    #dialogElement
    class="dialog"
    role="document"
    tabindex="-1"
  >
    <ng-content></ng-content>
  </div>
</div>
